export default "__VITE_ASSET__C2WKD_5x__"